// One route-managed data script lets React retain it during hydration and
// replace it on navigation, rather than injecting additional copies.
export function structuredDataScript(data: unknown[]) {
	return {
		id: "page-structured-data",
		type: "application/ld+json",
		children: JSON.stringify(data.flat()).replace(/</g, "\\u003c"),
	};
}

export function breadcrumbSchema(canonical: string, name: string) {
	return {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		"@id": `${canonical}#breadcrumb`,
		itemListElement: [
			{
				"@type": "ListItem",
				position: 1,
				name: "Home",
				item: "https://miamibraces.com/",
			},
			{ "@type": "ListItem", position: 2, name, item: canonical },
		],
	};
}
